import { useState } from "react";
import { ErrorIcon, SuccessIcon } from "./Icons";
import { Message } from "wvus-forms";
import { CreditCardTypes } from "./CreditCardTypes";
import CreditCardTokenExField from "./CreditCardTokenExField";
import Shimmer from "./Shimmer";
import { getPhrase, Say } from "../../languages";

export function CreditCardField(props) {
  const {
    tokenExConfigQuery,
    refIframe,
    secondInteraction,
    validationErrorCCPhraseKey,
    handleIframeError,
    handleIframeLoadError,
    fieldAlertMessagePhraseKey,
    onCardTypeChange = () => {},
    onTokenize = () => {},
    onValidate = () => {},
    onExpire = () => {},
    onBlur = () => {},
    onFocus = () => {},
    isCCValid,
    cardType,
    disabled,
    setTokenExError
  } = props;
  const [isComplete, setIsComplete] = useState(false);
  const isLoading = tokenExConfigQuery?.status === "loading" && isComplete === true;
  const iframeConfig = tokenExConfigQuery?.data || {};
  const iframeConfigRefresh = tokenExConfigQuery?.refresh || (() => {});

  return (
    <>
      <Shimmer
        className="payment-field-shimmer"
        isLoading={isLoading || disabled}
        height="43px"
        width="100%">
        <CreditCardTokenExField
          iframeConfig={iframeConfig}
          iframeConfigRefresh={iframeConfigRefresh}
          fieldId="wvus_new_cc_number"
          refIframe={refIframe}
          onCardTypeChange={onCardTypeChange}
          setTokenExError={setTokenExError}
          handleIframeError={handleIframeError}
          handleIframeLoadError={handleIframeLoadError}
          onTokenize={onTokenize}
          onExpire={onExpire}
          onValidate={onValidate}
          onBlur={onBlur}
          onFocus={onFocus}
          onLoad={() => {
            setIsComplete(true);
          }}
          onInitTimeout={() => {
            // TODO: Determine what to do with a timeout error
            // setTokenExStatus("error");
          }}
          isValid={isCCValid}
          secondInteraction={secondInteraction}
          fieldAlertMessagePhraseKey={fieldAlertMessagePhraseKey}
          renderMessage={() => {
            if (!isCCValid && secondInteraction) {
              return (
                <Say phrase="errors.valid_credit_card">
                  <Message
                    showError={true}
                    showSuccess={false}
                    message={getPhrase(validationErrorCCPhraseKey)}
                    errorIcon={<ErrorIcon />}
                  />
                </Say>
              );
            } else if (isCCValid) {
              return (
                <Message
                  showError={false}
                  showSuccess={true}
                  message=""
                  successIcon={<SuccessIcon />}
                />
              );
            }

            return null;
          }}
        />
      </Shimmer>
      <CreditCardTypes activeType={cardType} />
    </>
  );
}

export default CreditCardField;
